import { styled } from '@linaria/react'
import { BorderOuterSC } from 'atoms/BorderOuter'
import { Card } from '../Card'

/**
 * Extras content sits in `CardChildContentSC` (`z-index: 100`), so without this
 * bump the purchase badge on `BorderOuterSC` is painted underneath the gradient
 * cover or banner artwork.
 */
export const BundleCardRootSC = styled(Card)`
  && ${BorderOuterSC} {
    z-index: 101;
  }
`
